// ignore-string-externalization
import React from "react";
export var NotFound = /*#__PURE__*/ React.lazy(function() {
    return import(/* webpackChunkName: "not-found" */ "./NotFound");
});
